import Divider from '@mui/material/Divider';
import { AgGridReact } from "ag-grid-react";
import { useState } from 'react';

function Treatments() {

    const defaultColDef = {
        flex: 1,
    };
    const [colDefs, setColDefs] = useState([
        { field: "drugName", headerName: "Drug Name & Strength" },
        { field: "dosage", headerName: "Dosage" },
        { field: "frequency", headerName: "How Often" },
    ]);
    const [rowData, setRowData] = useState([
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
    ]);

    return (
        <>
            <main style={{ width: "100%", height: "100%" }}>
                <div className="row">
                    <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

                        <div className="d-flex">
                            <h4 className='m-0 p-3'>
                                Treatments
                            </h4>

                        </div>

                        <div className='d-flex align-items-center justify-content-end gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <div className="position-relative div-okij8ijj">
                                    <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                                    <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                                        <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
           
        </div> */}
                </div>
                <div className="row">
                    <div style={{ height: "42rem" }} className="col-12 row">
                        <div className="col-5 p-3" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%" }}>
                            <span style={{ backgroundColor: "#C6FFD7", borderRadius: "5px", cursor: "pointer" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                <span>
                                    <img src="/Images/Group9.png" alt="" />
                                </span>
                                <span className="d-flex flex-column align-items-start">
                                    <span className="m-1">Diabetes</span>
                                    <span style={{ color: "gray" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                </span>
                                <span className="d-flex flex-column align-items-start">
                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Rahul</span></span>
                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                </span>
                            </span>
                        </div>

                        <div className="col-7 px-3">
                            <div className="col-12 d-flex flex-column" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%", backgroundColor: "white" }}>
                                <div className="d-flex py-3 px-4 col-12" style={{ borderBottom: "1px dashed gray" }}>
                                    <span>Diagnosis</span>
                                </div>
                                <div className="d-flex flex-column px-4 py-4">
                                    <div className="d-flex align-items-center justify-content-between my-2">
                                        <h5>Rohan</h5>
                                        <span>Age : 68</span>
                                        <span>Blood Group : O+</span>
                                        <span>BP : 120/80</span>
                                        <span>Pulse : 40 – 60 bpm</span>
                                        <span style={{ color: "gray" }}>#123456abc</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between my-2">
                                        <span className="d-flex">Assigned to <span className="mx-1" style={{ color: "#2662F0" }}>DR.Shanthi</span></span>
                                        <span className="d-flex">Department <span className="mx-1" style={{ color: "#2662F0" }}>General Physician</span></span>
                                        <span style={{ color: "gray" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                                    </div>
                                    <Divider className="my-2" style={{ borderColor: "gray" }} />
                                    <div className="d-flex flex-column">
                                        <p><strong>Chief Complaint:</strong></p>
                                        <p>Frequent urination, excessive thirst, fatigue, and blurred vision.</p>

                                        <p><strong>Medical History:</strong></p>
                                        <p>Family history of diabetes: Yes</p>
                                        <p>Previous diagnosis of diabetes: No</p>
                                        <p>Other relevant medical conditions: Hypertension</p>
                                        <p>Medications currently taking: Lisinopril</p>

                                        <p><strong>Clinical Findings:</strong></p>
                                        <p>Fasting Blood Glucose Level: 160 mg/dL</p>
                                        <p>Postprandial Blood Glucose Level: 220 mg/dL</p>
                                        <p>HbA1c Level: 8.2%</p>
                                        <p>Urinalysis: Glucose present</p>
                                        <p>Blood Pressure: 140/90 mmHg</p>
                                        <p>BMI: 28.5 kg/m²</p>

                                        <p><strong>Diagnosis:</strong></p>
                                        <p>Based on the test results and clinical presentation, the patient is diagnosed with:</p>
                                        <ul>
                                            <li>Type 2 Diabetes Mellitus</li>
                                        </ul>

                                        <p><strong>Recommended Treatment Plan:</strong></p>
                                        <p>1. <strong>Lifestyle Modifications:</strong></p>
                                        <ul>
                                            <li>Dietary changes (low-carb, high-fiber diet, portion control)</li>
                                            <li>Regular physical activity (at least 30 minutes of exercise per day)</li>
                                            <li>Weight management</li>
                                        </ul>

                                        <p>2. <strong>Medication (if applicable):</strong></p>
                                        <ul>
                                            <li>Oral hypoglycemic agents: Metformin 500mg twice daily</li>
                                        </ul>

                                        <p>3. <strong>Monitoring Plan:</strong></p>
                                        <ul>
                                            <li>Regular blood glucose monitoring (self-testing and laboratory tests)</li>
                                            <li>Periodic HbA1c testing (every 3-6 months)</li>
                                            <li>Routine checkups for diabetes-related complications</li>
                                        </ul>

                                        <p>4. <strong>Complications Screening:</strong></p>
                                        <ul>
                                            <li>Diabetic retinopathy screening</li>
                                            <li>Neuropathy and foot care examination</li>
                                            <li>Kidney function tests (urine microalbumin and serum creatinine)</li>
                                            <li>Cardiovascular risk assessment</li>
                                        </ul>

                                        <p><strong>Patient Education & Lifestyle Counseling:</strong></p>
                                        <ul>
                                            <li>Importance of blood sugar control</li>
                                            <li>Recognizing symptoms of hypo/hyperglycemia</li>
                                            <li>Medication adherence and insulin administration techniques</li>
                                            <li>Smoking cessation and alcohol moderation</li>
                                            <li>Stress management techniques</li>
                                        </ul>

                                        <p><strong>Follow-up Plan:</strong></p>
                                        <p>Next scheduled appointment: March 1, 2025</p>
                                        <p>Additional referrals (if necessary): Endocrinologist, Dietitian</p>

                                        <p><strong>Physician’s Notes:</strong></p>
                                        <p>Patient advised to closely monitor blood glucose levels and adhere to prescribed medications and lifestyle changes.</p>

                                        <p><strong>Physician’s Signature:</strong></p>
                                        <p>___________________________</p>
                                        <p>DR. Santhi</p>
                                        <p>MD, Endocrinology</p>
                                        <p>City Health Clinic</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>





            </main >

        </>
    )
}

export default Treatments